import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

interface Props {
    label: ReactNode
    /** Dot + border colour (and default border). */
    color?: string
    /** Optional override for the border colour (defaults to `color`). */
    borderColor?: string
    /** Optional trailing muted text (e.g. a timestamp). */
    secondary?: ReactNode
    /** Pill background. */
    bg?: string
    size?: 'small' | 'medium'
}

// Rounded status/config pill: a coloured dot + label, with optional muted
// trailing text. Used for boat status, ownership status, and on/off config
// flags so they all speak the same visual language.
const UniversalStatusPill = ({
    label,
    color = '#9AA0A6',
    borderColor,
    secondary,
    bg = 'rgba(0,0,0,0.25)',
    size = 'medium',
}: Props) => {
    const pad = size === 'small' ? { px: 1, py: 0.4 } : { px: 1.25, py: 0.5 }
    const dot = size === 'small' ? 7 : 8
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                ...pad,
                borderRadius: 999,
                border: '1px solid',
                borderColor: borderColor || color,
                bgcolor: bg,
            }}
        >
            <Box
                sx={{
                    width: dot,
                    height: dot,
                    borderRadius: '50%',
                    bgcolor: color,
                    flexShrink: 0,
                }}
            />
            <Typography
                sx={{ fontSize: 12, fontWeight: 700, color: 'common.white' }}
            >
                {label}
            </Typography>
            {secondary !== undefined && secondary !== '' && (
                <Typography
                    sx={{
                        fontSize: 11,
                        fontWeight: 500,
                        color: 'rgba(255,255,255,0.55)',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {secondary}
                </Typography>
            )}
        </Box>
    )
}

export default UniversalStatusPill
